import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Collapse,
  Divider,
  Stack,
  TextField,
  Typography,
  useTheme
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import {
  CodedByType,
  DocumentIdType,
  FacilityType,
  GenderType,
  PayorType,
  // SpecialtyType,
  StatusType
} from "./Model";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDateRangePicker } from "@mui/x-date-pickers-pro/DesktopDateRangePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SingleInputDateRangeField } from "@mui/x-date-pickers-pro/SingleInputDateRangeField";
//import { DateRange } from "@mui/x-date-pickers-pro/models";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../reduxStore/store";

import { useAppSelector } from "../../reduxStore/hooks";
// import { DocumentStatusListReq } from "../../reduxStore/getDocumentStatusList/Model";
import { DateTimeRangePicker } from "@mui/x-date-pickers-pro/DateTimeRangePicker";
import dayjs, { Dayjs } from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";

interface SearchFormProps {
  open: boolean;
}

function NewSearchForm({ open }: SearchFormProps) {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const submittedObjRaw = query.get("obj");
  const obj = React.useMemo(() => {
    let parsedObj: Record<string, any> = {};
    if (submittedObjRaw) {
      try {
        parsedObj = JSON.parse(submittedObjRaw);
      } catch (error) {
        console.error("Invalid submittedObj JSON", error);
      }
    }
    return parsedObj;
  }, [submittedObjRaw]);
  const token = localStorage.getItem("access");
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const themeMode = localStorage.getItem("colorMode") as string;
  const [toggleFormSize, setToggleFormSize] = React.useState(false);
  const [searchFormState, setSearchFormState] = React.useState(false);
  
  // const documentListValue = useAppSelector(
  //   (state) => state.getDocumentListResponse
  // );
  useEffect(() => {
    setSearchFormState(open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    setSelectedStatus(obj.status);
    setSelectedPayor(obj.payor);
    setAppointmentType(obj.appointmentType);
    setVisit(obj.visitNumber);
    setMRN(obj.mrn);
    setAge(obj.age);
    setRenderingProviderName(obj.renderingProvider);
    setSuporvisingProviderName(obj.supervisingProvider);
    setProcedures(obj.cptCode);
    setDiagnoses(obj.icd10Code);
    setModifiers(obj.cptModifier);
    setEncounter(obj.encounter);
  }, [obj]);

  const [documentId] = useState([] as DocumentIdType[]);
  const [selectedDocumentId, setSelectedDocumentId] =
    useState<DocumentIdType | null>(null);
  const changeDocumentId = (passedVal: null) => {
    passedVal !== null && setSelectedDocumentId(passedVal);
  };

  const [codedBy] = useState([] as CodedByType[]);
  const [filteredCodedBy, setFilteredCodedBy] = useState([] as CodedByType[]);
  const [selectedCodedBy, setSelectedCodedBy] = useState<CodedByType | null>(
    null
  );
  const changeCodedBy = (passedVal: null) => {
    passedVal !== null && setSelectedCodedBy(passedVal);
  };
  const [selectedAuditedBy, setSelectedAuditedBy] =
    useState<CodedByType | null>(null);
  const changeAuditedBy = (passedVal: null) => {
    passedVal !== null && setSelectedAuditedBy(passedVal);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const staticFacilityList = [
    {
      label: "Apollo Hospital",
      value: 1
    },
    {
      label: "Cleveland Clinic",
      value: 2
    },
    {
      label: "Johns Hopkins Hospital",
      value: 3
    },
    {
      label: "Massachusetts General Hospital",
      value: 4
    }
  ] as FacilityType[];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let staticGenderList = [
    {
      label: "Male",
      value: "Male"
    },
    {
      label: "Female",
      value: "Female"
    },
    {
      label: "Other",
      value: "Other"
    }
  ] as GenderType[];

  // const [genderList, setGenderList] = useState(staticGenderList);
  const [selectedGender, setSelectedGender] = useState<GenderType | null>(null);
  const changeGender = (passedVal: GenderType | null) => {
    passedVal !== null && setSelectedGender(passedVal);
  };
  // useEffect(() => {
  //   if (staticGenderList.length > 0) {
  //     setGenderList(staticGenderList);
  //   } else {
  //     setGenderList([] as GenderType[]);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [staticGenderList]);

  // const [facilityList, setFacilityList] = useState([] as FacilityType[]);
  const [selectedFacility, setSelectedFacility] = useState<FacilityType | null>(
    staticFacilityList[0]
  );
  const changeFacility = (passedVal: FacilityType | null) => {
    passedVal !== null && setSelectedFacility(passedVal);
  };
  // useEffect(() => {
  //   if (staticFacilityList.length > 0) {
  //     setFacilityList(staticFacilityList);
  //   } else {
  //     setFacilityList([] as FacilityType[]);
  //   }
  // }, [staticFacilityList]);

  const [statusList, setStatusList] = useState([] as StatusType[]);
  const [selectedStatus, setSelectedStatus] = useState<StatusType | null>(null);
  const changeStatus = (passedVal: StatusType | null) => {
    passedVal !== null && setSelectedStatus(passedVal);
  };
  // useEffect(() => {
  //   if (Object.keys(documentStatusListResponse?.response).length === 0) {
  //     dispatch(
  //       fetchDocumentStatusList({
  //         access: token
  //       } as DocumentStatusListReq)
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // useEffect(() => {
  //   if (documentListValue?.response?.documentFilterList !== undefined) {
  //     const documentListValues =
  //       documentListValue?.response?.documentFilterList.map((item) => ({
  //         value: item.id,
  //         label: String(item.id)
  //       }));
  //     setDocumentId(documentListValues);
  //   }
  //   const codedByValues = documentListValue?.response?.documentFilterList.map(
  //     (item) => ({
  //       value: item.codedBy,
  //       label: item.codedBy
  //     })
  //   );
  //   setCodedBy(codedByValues);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [documentListValue]);

  useEffect(() => {
    if (codedBy !== undefined) {
      const filtered = codedBy.map((item, index) => ({
        value: (index + 1).toString(),
        label: item.label
      }));
      setFilteredCodedBy(filtered);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codedBy]);
  // Update Document Status list from API
  

  const [dosValue, setDosValue] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null
  ]);
  const updateDateRange = (passedVal: any) => {
    setDosValue(passedVal);
  };
  const [receiveOn, setReceiveOn] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null
  ]);
  const updateDateRangeForReceiveOn = (passedVal: any) => {
    setReceiveOn(passedVal);
  };
  const [exportedOn, setExportedOn] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null
  ]);
  const updateDateRangeForExportedOn = (passedVal: any) => {
    setExportedOn(passedVal);
  };
  const [codedOn, setCodedOn] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null
  ]);
  const updateDateRangeForCodedOn = (passedVal: any) => {
    setCodedOn(passedVal);
  };
  const [auditedOn, setAuditedOn] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null
  ]);
  const updateDateRangeForAuditedOn = (passedVal: any) => {
    setAuditedOn(passedVal);
  };
  const [updatedOn, setUpdatedOn] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null
  ]);
  const updateDateRangeForUpdatedOn = (passedVal: any) => {
    setUpdatedOn(passedVal);
  };

  const [appointmentType, setAppointmentType] = useState("");
  const [visit, setVisit] = useState("");
  const [mrn, setMRN] = useState("");
  const [encounter, setEncounter] = useState("");
  const [age, setAge] = useState("");
  const [payorList, setPayorList] = useState([] as PayorType[]);
  const [selectedPayor, setSelectedPayor] = useState<PayorType | null>(null);
  // useEffect(() => {
  //   if (Object.keys(payerListResponse?.response).length === 0) {
  //     dispatch(
  //       fetchPayorList({
  //         access: token
  //       } as PayorListReq)
  //     );
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  // Update Payor list from API
 
  const changePayor = (passedVal: PayorType | null) => {
    passedVal !== null && setSelectedPayor(passedVal);
  };
  const [renderingProviderName, setRenderingProviderName] = useState("");
  const [suporvisingProviderName, setSuporvisingProviderName] = useState("");
  const [procedures, setProcedures] = useState("");
  const [diagnoses, setDiagnoses] = useState("");
  const [modifiers, setModifiers] = useState("");

  const resetForm = () => {
    console.log("resetForm");
    setSelectedDocumentId(null);
    setSelectedStatus(null);
    setAppointmentType("");
    setVisit("");
    setMRN("");
    setAge("");
    setSelectedPayor(null);
    setRenderingProviderName("");
    setSuporvisingProviderName("");
    setProcedures("");
    setDiagnoses("");
    setModifiers("");
    setEncounter("");
  };
  const submitForm = () => {
    setSearchFormState(false);
    if (selectedFacility?.label !== null) {
      let submittedObj = {
        documentId: selectedDocumentId?.value!,
        facility: selectedFacility?.value!,
        status: selectedStatus ? String(selectedStatus?.value) : null,
        dos:
          JSON.stringify(dosValue) !== JSON.stringify([null, null])
            ? String(dayjs(dosValue[0]).format("YYYY-MM-DDTHH:mm:ss"))
            : null,
        mrn: mrn!,
        payor: selectedPayor ? String(selectedPayor?.value) : null,
        visitNumber: visit ? Number(visit) : null,
        receivedOn:
          JSON.stringify(receiveOn) !== JSON.stringify([null, null])
            ? String(dayjs(receiveOn[0]).format("YYYY-MM-DDTHH:mm:ss"))
            : null,
        exportedOn:
          JSON.stringify(exportedOn) !== JSON.stringify([null, null])
            ? String(dayjs(exportedOn[0]).format("YYYY-MM-DDTHH:mm:ss"))
            : null,
        codedBy: selectedCodedBy ? Number(selectedCodedBy?.value!) : null,
        codedOn:
          JSON.stringify(codedOn) !== JSON.stringify([null, null])
            ? String(dayjs(codedOn[0]).format("YYYY-MM-DDTHH:mm:ss"))
            : null,
        updatedOn:
          JSON.stringify(updatedOn) !== JSON.stringify([null, null])
            ? String(dayjs(updatedOn[0]).format("YYYY-MM-DDTHH:mm:ss"))
            : null,
        encounter: encounter!,
        auditedBy: selectedAuditedBy ? Number(selectedAuditedBy?.value) : null,
        auditedOn:
          JSON.stringify(auditedOn) !== JSON.stringify([null, null])
            ? String(dayjs(auditedOn[0]).format("YYYY-MM-DDTHH:mm:ss"))
            : null,
        appointmentType: appointmentType,
        gender: selectedGender !== null ? String(selectedGender?.value!) : null,
        age: age!,
        renderingProvider: renderingProviderName,
        supervisingProvider: suporvisingProviderName,
        cptCode: procedures,
        cptModifier: modifiers,
        icd10Code: diagnoses
      };      
    } else {
      alert("All Fields are mandatory");
    }
  };
  return (
    <Box
      style={{
        border: "2px",
        borderRadius: "15px;",
        position: "absolute",
        zIndex: 8,
        padding: "10px",
        width: "100%",
        marginTop: "40px"
      }}
    >
      {searchFormState === true ? (
        <Card
          // style={{ background: themeMode! === "light" ? "white" : "#0d4b4e" }}
        >
          <CardContent sx={{ maxHeight: "85vh", overflow: "auto" }}>
            <Stack
              direction="column"
              spacing={2}
              sx={{
                justifyContent: "flex-start",
                alignItems: "stretch"
              }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
                spacing={2}
              >
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    textAlign={"left"}
                  >
                    Document ID
                  </Typography>
                </Grid>
                <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                  <Autocomplete
                    id="documentId"
                    value={selectedDocumentId}
                    options={documentId}
                    onChange={(_event: any, newValue: any) => {
                      changeDocumentId(newValue);
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Document Id"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
                spacing={2}
              >
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    textAlign={"left"}
                  >
                    Facility*
                  </Typography>
                </Grid>
                <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                  <Autocomplete
                    id="facility"
                    value={selectedFacility}
                    options={staticFacilityList}
                    onChange={(_event: any, newValue: any) => {
                      changeFacility(newValue);
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Facility"
                        variant="outlined"
                        fullWidth
                        required
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
                spacing={2}
              >
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    textAlign={"left"}
                  >
                    Status
                  </Typography>
                </Grid>
                <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                  <Autocomplete
                    id="status"
                    disableClearable
                    value={selectedStatus}
                    options={statusList}
                    onChange={(_event: any, newValue: any) => {
                      changeStatus(newValue);
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Status"
                        variant="outlined"
                        fullWidth
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
                spacing={2}
              >
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    textAlign={"left"}
                  >
                    DOS
                  </Typography>
                </Grid>
                <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimeRangePicker
                      value={dosValue}
                      onChange={(newValue: any) => updateDateRange(newValue)}
                      slots={{ field: SingleInputDateRangeField }}
                      name="allowedRange"
                      slotProps={{
                        field: {
                          sx: {
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              },
                              "&:hover fieldset": {
                                borderColor:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              },
                              "&.Mui-focused fieldset": {
                                borderColor:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              },
                              fontSize: "15px",
                              height: "40px",
                              width: "510px",
                              color:
                                theme.palette.mode === "dark" ? "#fff" : "#000"
                            }
                          }
                        }
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
                spacing={2}
              >
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    textAlign={"left"}
                  >
                    Appointment Type
                  </Typography>
                </Grid>
                <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                  <TextField
                    value={appointmentType}
                    onChange={(e: any) => setAppointmentType(e.target.value)}
                    label="Appointment Type"
                    placeholder="Enter Your Appointment Type"
                    size="small"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid
                container
                direction="row"
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "center"
                }}
                spacing={2}
              >
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                  <Typography
                    variant="subtitle1"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    textAlign={"left"}
                  >
                    Visit
                  </Typography>
                </Grid>
                <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                  <TextField
                    value={visit}
                    onChange={(e) => setVisit(e.target.value)}
                    label="Visit"
                    placeholder="Enter Your Visit No"
                    size="small"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Stack>
            <Collapse in={toggleFormSize}>
              <Stack
                direction="column"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "stretch"
                }}
                marginTop={5}
              >
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    style={{ textAlign: "left" }}
                  >
                    Patient Information
                  </Typography>
                  <Divider />
                </Box>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      MRN:
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={mrn}
                      onChange={(e: any) => setMRN(e.target.value)}
                      label="MRN"
                      placeholder="Enter Your MRN No"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Age:
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={age}
                      onChange={(e: any) => setAge(e.target.value)}
                      label="Age"
                      placeholder="Enter Your Age"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Gender:
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <Autocomplete
                      id="genderId"
                      disableClearable
                      value={selectedGender}
                      options={staticGenderList}
                      onChange={(_event: any, newValue: any) => {
                        changeGender(newValue);
                      }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Gender"
                          placeholder="Select gender"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Payor:
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <Autocomplete
                      id="payor"
                      disableClearable
                      value={selectedPayor}
                      options={payorList}
                      onChange={(_event: any, newValue: any) => {
                        changePayor(newValue);
                      }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Payor"
                          placeholder="Select"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                direction="column"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "stretch"
                }}
                marginTop={5}
              >
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    style={{ textAlign: "left" }}
                  >
                    Provider Information
                  </Typography>
                  <Divider />
                </Box>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Rendering Provider
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={renderingProviderName}
                      onChange={(e: any) =>
                        setRenderingProviderName(e.target.value)
                      }
                      label="Rendering Provider"
                      placeholder="Enter your Rendering Provider"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Supervising Provider
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={suporvisingProviderName}
                      onChange={(e: any) =>
                        setSuporvisingProviderName(e.target.value)
                      }
                      label="Supervising Provider"
                      placeholder="Enter your Supervising Provider"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                direction="column"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "stretch"
                }}
                marginTop={5}
              >
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    style={{ textAlign: "left" }}
                  >
                    Coding Information
                  </Typography>
                  <Divider />
                </Box>

                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Procedure(s)
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={procedures}
                      onChange={(e: any) => setProcedures(e.target.value)}
                      label="Procedure(s)"
                      placeholder="Enter Procedure(s)"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Diagnoses
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={diagnoses}
                      onChange={(e: any) => setDiagnoses(e.target.value)}
                      label="Diagnoses"
                      placeholder="Enter Diagnoses"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Modifier(s)
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={modifiers}
                      onChange={(e: any) => setModifiers(e.target.value)}
                      label="Modifier(s)"
                      placeholder="Enter Modifier(s)"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Stack>
              <Stack
                direction="column"
                spacing={2}
                sx={{
                  justifyContent: "flex-start",
                  alignItems: "stretch"
                }}
                marginTop={5}
              >
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight={"bold"}
                    fontSize={"14px"}
                    style={{ textAlign: "left" }}
                  >
                    Other Information
                  </Typography>
                  <Divider />
                </Box>

                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Received On
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDateRangePicker
                        value={receiveOn}
                        onChange={(newValue) =>
                          updateDateRangeForReceiveOn(newValue)
                        }
                        slots={{ field: SingleInputDateRangeField }}
                        name="allowedRange"
                        slotProps={{
                          field: {
                            sx: {
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&:hover fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                fontSize: "15px",
                                height: "40px",
                                width: "510px",
                                color:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              }
                            }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Exported On
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDateRangePicker
                        value={exportedOn}
                        onChange={(newValue) =>
                          updateDateRangeForExportedOn(newValue)
                        }
                        slots={{ field: SingleInputDateRangeField }}
                        name="allowedRange"
                        slotProps={{
                          field: {
                            sx: {
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&:hover fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                fontSize: "15px",
                                height: "40px",
                                width: "510px",
                                color:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              }
                            }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Coded By
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <Autocomplete
                      id="codedId"
                      value={selectedCodedBy}
                      options={filteredCodedBy}
                      onChange={(_event: any, newValue: any) => {
                        changeCodedBy(newValue);
                      }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Coded By"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Coded On
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDateRangePicker
                        value={codedOn}
                        onChange={(newValue) =>
                          updateDateRangeForCodedOn(newValue)
                        }
                        slots={{ field: SingleInputDateRangeField }}
                        name="allowedRange"
                        slotProps={{
                          field: {
                            sx: {
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&:hover fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                fontSize: "15px",
                                height: "40px",
                                width: "510px",
                                color:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              }
                            }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Audited On
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDateRangePicker
                        value={auditedOn}
                        onChange={(newValue) =>
                          updateDateRangeForAuditedOn(newValue)
                        }
                        slots={{ field: SingleInputDateRangeField }}
                        name="allowedRange"
                        slotProps={{
                          field: {
                            sx: {
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&:hover fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                fontSize: "15px",
                                height: "40px",
                                width: "510px",
                                color:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              }
                            }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Updated on
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopDateRangePicker
                        value={updatedOn}
                        onChange={(newValue) =>
                          updateDateRangeForUpdatedOn(newValue)
                        }
                        slots={{ field: SingleInputDateRangeField }}
                        name="allowedRange"
                        slotProps={{
                          field: {
                            sx: {
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&:hover fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor:
                                    theme.palette.mode === "dark"
                                      ? "#fff"
                                      : "#000"
                                },
                                fontSize: "15px",
                                height: "40px",
                                width: "510px",
                                color:
                                  theme.palette.mode === "dark"
                                    ? "#fff"
                                    : "#000"
                              }
                            }
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Encounter
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <TextField
                      value={encounter}
                      onChange={(e: any) => setEncounter(e.target.value)}
                      label="Encounter"
                      placeholder="Enter Encounter"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-start",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={"bold"}
                      fontSize={"14px"}
                      textAlign={"left"}
                    >
                      Audited By
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                    <Autocomplete
                      id="auditedId"
                      value={selectedAuditedBy}
                      options={filteredCodedBy}
                      onChange={(_event: any, newValue: any) => {
                        changeAuditedBy(newValue);
                      }}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Audited By"
                          variant="outlined"
                          fullWidth
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                    />
                  </Grid>
                </Grid>
              </Stack>
            </Collapse>
          </CardContent>
          <CardActions>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
              }}
            >
              <Grid size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
                <Button
                  variant="text"
                  onClick={() => setToggleFormSize(!toggleFormSize)}
                  fullWidth
                >
                  <Typography textTransform={"none"}>
                    Show {toggleFormSize ? "Less" : "More"}
                  </Typography>
                </Button>
              </Grid>
              <Grid size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 10 }}>
                <Grid
                  container
                  direction="row"
                  sx={{
                    justifyContent: "flex-end",
                    alignItems: "center"
                  }}
                  spacing={2}
                >
                  <Grid>
                    <Button variant="text" onClick={() => resetForm()}>
                      <Typography textTransform={"none"}>Reset</Typography>
                    </Button>
                  </Grid>
                  <Grid>
                    <Button
                      variant="contained"
                      onClick={() => submitForm()}
                      disabled={selectedFacility !== null ? false : true}
                    >
                      <Typography textTransform={"none"}>Submit</Typography>
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      ) : null}
    </Box>
  );
}

export default NewSearchForm;
